import { createSlice } from "@reduxjs/toolkit";
import { getSurveyResponsesList } from "../../api/rewardDataGw/rewardDataGw";

// giá trị khởi tạo của state
const initialState = {
  listResponses: [],
  isListResponses: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const surveyResponsesSlice = createSlice({
  name: "surveyResponses", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSurveyResponsesList.pending, (state) => {
        state.isListResponses = true;
        state.error = null;
      })
      .addCase(getSurveyResponsesList.fulfilled, (state, action) => {
        state.isListResponses = false;
        state.listResponses = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getSurveyResponsesList.rejected, (state, action) => {
        state.isListResponses = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  surveyResponsesSlice.actions;
export default surveyResponsesSlice.reducer;
